module.exports = __webpack_public_path__ + "img/hero-band-pc.2168a1f4.svg";